import cssString from "../src/styles/_minified/index.css"
import modalCssString from "../src/styles/_minified/modal.css"
import layoutCssString from "../src/styles/_minified/layout.css"
import uploadCssString from "../src/styles/_minified/upload-zone.css"
import errorsCssString from "../src/styles/_minified/layout-errors.css"
import viewerCssString from "../src/styles/_minified/layouts-viewer.css"

// ui
import {
    createArrowBottomCircle,
    createChevronLeftIcon,
    createCloseIcon,
    createEyeIcon,
    createFullscreenIcon,
    createLayout,
    createLegendLine,
    createModal,
    createTrashIcon
} from "./utils/createElemets"
import { UploadZone } from "./ui/UploadZone"
import "@material/web/textfield/outlined-text-field"

// @types
import { LayoutsState, LayoutState } from "./types/types"

// test JSON
import * as testData from "../test.json"
import { UploadZoneMultipleTypes } from "./ui/UploadZoneMultipleTypes"
import { LayoutsViewer } from "./ui/LayoutsViewer"

// --------------------------------------------------------------------------------

window.layoutsState = {}
window.layoutsUploadModal = null

window.ondragover = function (e) { e.preventDefault(); return false }
window.ondrop = function (e) { e.preventDefault(); return false }

export const BASE_API_URL: string = window.isDevBuild ? 'https://elnar.tippo.ru' : ''

const font = document.createElement("link")
font.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500&family=Manrope:wght@200;300;400;500;600;700;800&display=swap"
font.rel = "stylesheet"
document.head.append(font)

export class LayoutsUploadModal extends HTMLElement {
    #currentStep: number

    #modal: HTMLDivElement
    #uploadView: HTMLDivElement
    #uploadSections: HTMLDivElement
    #layoutsView: HTMLDivElement
    #layoutsSections: HTMLDivElement

    #footerStepOne: HTMLDivElement
    #footerStepOneSubmitBtn: HTMLButtonElement
    #footerStepOneLabel: HTMLLabelElement

    #footerStepTwo: HTMLDivElement
    #footerStepTwoSubmitBtn: HTMLButtonElement
    #footerStepTwoLabel: HTMLLabelElement

    #uploadZonesMultipleTypes: UploadZoneMultipleTypes[]
    uploadZones: UploadZone[]
    twoSidePdf: boolean

    constructor() {
        super()

        this.#currentStep = 1

        layoutsState = new Proxy(layoutsState, this.#proxyHandler(this))
        this.#uploadZonesMultipleTypes = []
        this.uploadZones = []
        this.twoSidePdf = false

        // Modal ----------
        this.#modal = document.createElement('div')
        this.#modal.classList.add('layouts-upload-modal')
        const modalCloseBtn = document.createElement('button')
        modalCloseBtn.append('Закрыть', createCloseIcon('var(--gray-500, #A0AEC0)'))
        modalCloseBtn.onclick = () => {
            this.remove()
        }
        this.#modal.append(modalCloseBtn)

        // Footer ----------
        this.#footerStepOne = document.createElement('div')

        this.#footerStepOneSubmitBtn = document.createElement('button')
        this.#footerStepOneSubmitBtn.type = 'button'
        this.#footerStepOneSubmitBtn.textContent = 'К согласованию макета'
        this.#footerStepOneSubmitBtn.disabled = true
        this.#footerStepOneSubmitBtn.onclick = () => {
            const zonesInvalid = this.#uploadZonesMultipleTypes.map(zone => zone.validate()).includes(false)
            if (this.#currentStep === 1 && !zonesInvalid)
                this.step = 2
        }

        this.#footerStepOneLabel = document.createElement('label')
        this.#footerStepOneLabel.textContent = 'Да, я ознакомился с замечаниями к макетам'
        const inputOne = document.createElement('input')
        inputOne.type = 'checkbox'
        inputOne.onchange = e => {
            const zonesInvalid = this.#uploadZonesMultipleTypes.map(zone => zone.circulationDistributed).includes(false)
            if ((e.currentTarget as HTMLInputElement).checked && !zonesInvalid)
                this.#footerStepOneSubmitBtn.disabled = false
            else
                this.#footerStepOneSubmitBtn.disabled = true
        }
        this.#footerStepOneLabel.prepend(inputOne)

        this.#footerStepOne.append(this.#footerStepOneSubmitBtn)

        this.#footerStepTwo = document.createElement('div')

        this.#footerStepTwoSubmitBtn = document.createElement('button')
        this.#footerStepTwoSubmitBtn.type = 'button'
        this.#footerStepTwoSubmitBtn.textContent = 'Согласовываю'
        this.#footerStepTwoSubmitBtn.disabled = true
        this.#footerStepTwoSubmitBtn.onclick = () => {

            if (window.positionId) {

                let indexes: string[] = []
                let numberSpecies: Record<string, string | string[] | number>[] = []
                Object.values(layoutsState).forEach(layoutState => {
                    layoutState.forEach(state => {
                        if (state)
                            indexes.push(state.uploadResData.index)

                        if (state && state.name && state.qty)
                            numberSpecies.push({
                                name: state.name,
                                circulation: state.qty,
                                indexes: [state.uploadResData.index]
                            })

                    })
                })

                const formData = new FormData()
                formData.append('layoutIndexes', JSON.stringify(indexes))
                formData.append('id', window.positionId)
                if (numberSpecies.length > 0)
                    formData.append('numberSpecies', JSON.stringify(numberSpecies))

                fetch(window.approvalLayoutUrl, {
                    method: 'POST',
                    body: formData
                })
                    .then(res => res.json() as Promise<{ layout: string, success: boolean, html?: string }>)
                    .then(res => {

                        if (cartUploadItemParent)
                            if (res.html && cartUploadItemParent.parentElement) {
                                cartUploadItemParent.parentElement.innerHTML = res.html

                                $('.count-views-slider-wrap').each(function (index, item) {
                                    let slider = $(item)
                                    slider.find('.slider-inner').slick({
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        infinite: false,
                                        prevArrow: slider.find('.control-prev'),
                                        nextArrow: slider.find('.control-next')
                                    })
                                    slider.find('.slider-inner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                                        let slide = slider.find(`.slick-slide[data-slick-index=${nextSlide}]`)
                                        let name = slide.attr('data-name')
                                        let circulation = slide.attr('data-circulation')
                                        let label = slide.attr('data-label')
                                        let productPosition = slide.parents('.cart__positions-item')

                                        if (label)
                                            productPosition.find('.specie-name').html(label)
                                        if (name)
                                            productPosition.find('.cart-specie-name').html(name)
                                        if (circulation)
                                            productPosition.find('.circulation-value').html(circulation)
                                        productPosition.find('.specie-index span').html(nextSlide)

                                    })
                                })

                            } else {
                                cartUploadItemParent.innerHTML = ''

                                cartUploadItemParent.style.backgroundImage = `url('${res.layout}')`

                                const dataImageEl = document.createElement('div')
                                dataImageEl.dataset.image = res.layout
                                dataImageEl.classList.add('big', 'position-absolute', 'w-100', 'h-100', 'slider-modal-item')
                                dataImageEl.dataset.position = window.positionId

                                cartUploadItemParent.append(dataImageEl)
                                cartUploadItemParent.nextElementSibling?.children[0].classList.remove("hidden")
                            }
                    })
                    .catch(e => console.log(e))
                    .finally(() => this.remove())

            } else {

                const uploadLayoutContainers = document.createElement('div')
                uploadLayoutContainers.classList.add('upload-layout-containers')
                uploadLayoutContainers.style.display = 'none'
                Object.values(layoutsState).forEach(layoutState => {

                    layoutState.forEach(state => {
                        if (state) {
                            const uploadLayoutContainer = document.createElement('div')
                            uploadLayoutContainer.classList.add('upload-layout-container')
                            uploadLayoutContainer.setAttribute('data-index', state.uploadResData.index)

                            if (state.partData.numberSpecies && +state.partData.numberSpecies > 1) {

                                if (state.name) {
                                    const nameInput = document.createElement('input')
                                    nameInput.classList.add('name_species')
                                    nameInput.value = state.name
                                    uploadLayoutContainer.append(nameInput)
                                }

                                if (state.qty) {
                                    const qtyInput = document.createElement('input')
                                    qtyInput.classList.add('number_species')
                                    qtyInput.value = `${state.qty}`
                                    uploadLayoutContainer.append(qtyInput)
                                }

                                const numberSpeciesItems = document.createElement('div')
                                numberSpeciesItems.classList.add('number_species_items')
                                numberSpeciesItems.append(uploadLayoutContainer)
                                uploadLayoutContainers.append(numberSpeciesItems)

                            } else
                                uploadLayoutContainers.append(uploadLayoutContainer)
                        }
                    })
                })
                document.body.append(uploadLayoutContainers)

                const submitButton = document.querySelector('.btn-create-layout') as HTMLButtonElement | null
                if (submitButton) {
                    submitButton.setAttribute('data-to-cart', '1')
                    submitButton.click()
                    this.remove()
                    setTimeout(() => uploadLayoutContainers.remove(), 1000)
                }
            }
        }

        this.#footerStepTwoLabel = document.createElement('label')
        this.#footerStepTwoLabel.textContent = 'Я ознакомился с требованиями по подготовке макета и подтверждаю соответствие макета требованиям. Макет не содержит орфографические ошибки и запрещенный контент.'
        const inputTwo = document.createElement('input')
        inputTwo.type = 'checkbox'
        inputTwo.onchange = e => {
            if ((e.currentTarget as HTMLInputElement).checked)
                this.#footerStepTwoSubmitBtn.disabled = false
            else
                this.#footerStepTwoSubmitBtn.disabled = true
        }
        this.#footerStepTwoLabel.prepend(inputTwo)

        const legend = document.createElement('div')
        legend.classList.add('legend')

        const cutLine = document.createElement('div')
        cutLine.classList.add('cut-line')
        const cutSpan = document.createElement('span')
        const cutName = document.createElement('b')
        cutName.textContent = 'Линия обреза'
        cutSpan.append(cutName, '— элементы макета, выходящие за эту линию будут отсутствовать в готовом изделии')
        cutLine.append(createLegendLine('var(--red-500, #F56565)'), cutSpan)

        const safeLine = document.createElement('div')
        safeLine.classList.add('safe-line')
        const safeSpan = document.createElement('span')
        const safeName = document.createElement('b')
        safeName.textContent = 'Линия безопасной области'
        safeSpan.append(safeName, '— важные элементы дизайна не должны выходить за границы данной линии')
        safeLine.append(createLegendLine('var(--green-500, #48BB78)'), safeSpan)

        legend.append(cutLine, safeLine)

        this.#footerStepTwo.append(this.#footerStepTwoSubmitBtn, this.#footerStepTwoLabel, legend)

        partsData?.forEach(partData => {
            if (partData.printingSides)
                layoutsState[partData.id] = window.isDevBuild
                    ? ((testData as unknown) as LayoutsState)[partData.id]
                    : new Array(partData.numberSpecies ? +partData.numberSpecies : partData.countPrintingSides ?? 1).fill(null)
        })

        // Upload view ----------
        this.#uploadView = document.createElement('div')

        const h2 = document.createElement('h2')
        h2.textContent = 'Загрузка макетов'

        const sectionsContainer = document.createElement('div')
        this.#uploadSections = document.createElement('div')
        this.#uploadSections.classList.add('sections')
        this.#updateUploadSections()

        const showAll = document.createElement('div')
        showAll.classList.add('show-all')
        showAll.append(createArrowBottomCircle(), 'Посмотреть всю информацию')

        sectionsContainer.append(this.#uploadSections)
        this.#uploadView.append(h2, sectionsContainer, showAll)

        // Layouts view ----------
        this.#layoutsView = document.createElement('div')

        const backBtn = document.createElement('button')
        backBtn.textContent = 'Назад к загрузке'
        backBtn.prepend(createChevronLeftIcon())
        backBtn.onclick = () => {
            this.step = 1
        }

        const layoutsH2 = document.createElement('h2')
        layoutsH2.textContent = 'Согласование и просмотр макетов'

        const layoutsSectionsContainer = document.createElement('div')
        this.#layoutsSections = document.createElement('div')
        this.#layoutsSections.classList.add('sections')
        this.#updateLayoutSections()

        layoutsSectionsContainer.append(this.#layoutsSections)
        this.#layoutsView.append(backBtn, layoutsH2, layoutsSectionsContainer)
    }

    get step() {
        return this.#currentStep
    }

    set step(number) {
        this.#currentStep = number
        if (number === 1) {
            this.#modal.replaceChild(this.#uploadView, this.#layoutsView)
            this.#modal.replaceChild(this.#footerStepOne, this.#footerStepTwo)
            this.#updateUploadSections()
        }
        else if (number === 2) {
            this.#modal.replaceChild(this.#layoutsView, this.#uploadView)
            this.#modal.replaceChild(this.#footerStepTwo, this.#footerStepOne)
        }
    }

    #updateUploadSections() {
        if (!this.#uploadSections) return
        this.#uploadSections.innerHTML = ''
        this.#uploadZonesMultipleTypes = []
        this.uploadZones = []
        this.twoSidePdf = false
        partsData?.forEach(partData => {
            if (!partData.printingSides) return

            const section = document.createElement('section')
            section.classList.add('uploads')

            const uploadZones = document.createElement('div')
            uploadZones.classList.add('upload-zones')

            if (partData.numberSpecies && +partData.numberSpecies > 1) {

                const uploadZone = new UploadZoneMultipleTypes(partData, this)
                uploadZones.append(uploadZone.view)
                this.#uploadZonesMultipleTypes.push(uploadZone)

            } else {

                const title = document.createElement('span')
                title.classList.add('title')
                title.textContent = partData.name

                const sides = partData.countPrintingSides ?? 1
                for (let i = 0; i < sides; i++) {
                    const uploadZone = new UploadZone(partData, i, this)
                    uploadZones.append(uploadZone.view)
                    this.uploadZones.push(uploadZone)
                }
                section.append(title)
            }

            section.append(uploadZones)
            this.#uploadSections.append(section)
        })
        setTimeout(() => {
            this.#uploadView.classList.toggle('scrollable', this.#uploadView.scrollHeight > this.#uploadView.offsetHeight)
        })
    }

    #updateLayoutSections() {
        if (!this.#layoutsSections) return
        this.#layoutsSections.innerHTML = ''
        partsData?.forEach((partData, index) => {
            if (!partData.printingSides) return

            const section = document.createElement('section')
            section.classList.add('layouts')

            const sectionTitle = document.createElement('span')
            sectionTitle.textContent = partData.name
            sectionTitle.classList.add('title')

            const sectionNumber = document.createElement('div')
            sectionNumber.classList.add('section-number')
            sectionNumber.textContent = `${index + 1}`
            sectionTitle.prepend(sectionNumber)

            const seeBtn = document.createElement('button')
            seeBtn.textContent = 'Смотреть подробнее'
            seeBtn.prepend(createEyeIcon())
            seeBtn.onclick = () => {
                new LayoutsViewer(partData.id, 0, 0, this.shadowRoot)
            }
            sectionTitle.append(seeBtn)

            const layouts = document.createElement('div')
            layouts.classList.add('layouts')

            layoutsState[partData.id].forEach((layoutState, index) => {
                if (!layoutState) return

                const layoutContainer = document.createElement('div')
                layoutContainer.classList.add('container')
                if (partData.isMultiPage === '1')
                    layoutContainer.classList.add('multi-page')

                if (partData.countPrintingSides && partData.countPrintingSides === 2) {
                    const layoutSpan = document.createElement('span')
                    layoutSpan.textContent = index === 0 ? 'Лицевая' : 'Оборотная'
                    layoutContainer.append(layoutSpan)
                }

                if (layoutState.checkResData) {

                    Object.values(layoutState.checkResData.result).forEach((result) => {
                        result.pages.forEach((pageObj, pageIndex) => {
                            Object.entries(pageObj).forEach(([number, page]) => {

                                const layout = createLayout(layoutState, page)
                                layout.classList.add('list')
                                const layoutRemoveBtn = document.createElement('button')

                                layoutRemoveBtn.classList.add('remove')
                                layoutRemoveBtn.append(createTrashIcon())
                                layoutRemoveBtn.onclick = () => createModal({
                                    title: 'Вы уверены что хотите удалить?',
                                    subTitle: 'Вы вернетесь в режим проверки и загрузки макетов',
                                    submitText: 'Да, удалить',
                                    cancelText: 'Отменить',
                                    action: () => {
                                        let temp = layoutsState[partData.id].slice()
                                        if (this.twoSidePdf) {
                                            temp[1] = null
                                            temp[0] = null

                                            this.twoSidePdf = false
                                        } else {
                                            temp[index] = null
                                        }

                                        layoutsState[partData.id] = temp
                                        this.step = 1
                                    }
                                }, this.shadowRoot)

                                const layoutExpandBtn = document.createElement('button')
                                layoutExpandBtn.classList.add('expand')
                                layoutExpandBtn.append(createFullscreenIcon())
                                layoutExpandBtn.onclick = () => {
                                    new LayoutsViewer(partData.id, layoutState.index, pageIndex, this.shadowRoot)
                                }

                                layout.append(layoutRemoveBtn, layoutExpandBtn)
                                layoutContainer.append(layout)
                            })
                            layouts.append(layoutContainer)
                        })
                    })

                } else {

                    const layout = createLayout(layoutState)
                    layout.classList.add('list')
                    const layoutRemoveBtn = document.createElement('button')

                    layoutRemoveBtn.classList.add('remove')
                    layoutRemoveBtn.append(createTrashIcon())
                    layoutRemoveBtn.onclick = () => createModal({
                        title: 'Вы уверены что хотите удалить?',
                        subTitle: 'Вы вернетесь в режим проверки и загрузки макетов',
                        submitText: 'Да, удалить',
                        cancelText: 'Отменить',
                        action: () => {
                            let temp = layoutsState[partData.id].slice()
                            temp[index] = null
                            layoutsState[partData.id] = temp
                            this.step = 1
                        }
                    }, this.shadowRoot)

                    const layoutExpandBtn = document.createElement('button')
                    layoutExpandBtn.classList.add('expand')
                    layoutExpandBtn.append(createFullscreenIcon())
                    layoutExpandBtn.onclick = () =>
                        new LayoutsViewer(partData.id, layoutState.index, 0, this.shadowRoot)

                    layout.append(layoutRemoveBtn, layoutExpandBtn)
                    layoutContainer.append(layout)
                    layouts.append(layoutContainer)
                }
            })

            section.append(sectionTitle, layouts)
            this.#layoutsSections.append(section)
        })
    }

    #proxyHandler = (component: this) => ({
        get(target: LayoutsState, key: string) {
            return target[key]
        },
        set(target: LayoutsState, key: string, value: (LayoutState | null)[]) {
            target[key] = value

            if (component.step === 2)
                component.#updateUploadSections()

            component.#updateLayoutSections()

            const agreementCheckBox = component.#footerStepOneLabel.children[0] as HTMLInputElement
            agreementCheckBox.checked = false

            const layouts = Object.values(target).flat()
            const hasMultipleType = layouts.map(layout => layout?.partData.numberSpecies && +layout.partData.numberSpecies > 1).includes(true)
            const hasErrors = layouts.map(layout => layout?.errors).includes(true)
            if (!layouts.includes(null) && !hasErrors) {
                const hasWarnings = layouts.map(layout => layout?.warnings).includes(true)
                if (hasWarnings) {
                    component.addWarningAgreement()
                } else if (!hasMultipleType) {
                    component.removeWarningAgreement()
                    component.enableSubmitBtn()
                }
            } else {
                component.disableSubmitBtn()
                component.removeWarningAgreement()
            }

            return true
        }
    })

    get agreementIsChecked() {
        return (this.#footerStepOneLabel.children[0] as HTMLInputElement).checked
    }

    get uploadView() {
        return this.#uploadView
    }

    addWarningAgreement() {
        this.#footerStepOne.append(this.#footerStepOneLabel)
    }

    removeWarningAgreement() {
        if (Array.from(this.#footerStepOne.children).includes(this.#footerStepOneLabel))
            this.#footerStepOne.removeChild(this.#footerStepOneLabel)
    }

    enableSubmitBtn() {
        this.#footerStepOneSubmitBtn.disabled = false
    }

    disableSubmitBtn() {
        this.#footerStepOneSubmitBtn.disabled = true
    }

    connectedCallback() {
        if (!partsData) return

        const shadow = this.attachShadow({ mode: "open" })

        const sheet = new CSSStyleSheet()
        sheet.replaceSync(cssString + modalCssString + layoutCssString + uploadCssString + errorsCssString + viewerCssString)
        shadow.adoptedStyleSheets = [sheet]

        this.#modal.append(this.#uploadView, this.#footerStepOne)

        const backgroundTint = document.createElement('div')
        backgroundTint.classList.add('background-tint')
        shadow.append(this.#modal, backgroundTint)

        layoutsUploadModal = this
    }

    disconnectedCallback() {
        window.layoutsState = {}
        window.layoutsUploadModal = null

        delete window.layoutExtensions
        delete window.partsData
        delete window.positionId
        delete window.cartUploadItemParent
        delete window.circulation
    }
}

customElements.define("layouts-upload-modal", LayoutsUploadModal)